import classnames from 'classnames/bind';
import hdate from 'human-date';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getMemberPriceStampInfoFromMemberName } from '../../../lib/utils';
import styles from './ReportedBy.module.css';
import { getTranslationFromHDateRelativeTime } from '../../../lib/utils/formatDateTime';

const cx = classnames.bind(styles);

export default function ReportedBy({ time, username }) {
  const { t } = useTranslation(['price', 'miscellaneous', 'dates']);
  const { iconPath, linkUrl } = getMemberPriceStampInfoFromMemberName(username);
  const UserElement = username ? 'a' : 'span';

  return (
    <div>
      <span className={cx('user')}>
        <UserElement className={cx('memberLink')} href={username && linkUrl}>
          <img src={iconPath} alt={t('priceReporterIcon', { ns: 'price' })} />
          &nbsp;
          {username || t('noReport', { ns: 'price' })}
        </UserElement>
      </span>
      <span className={cx('postedTime')}>
        {time
          ? getTranslationFromHDateRelativeTime(hdate.relativeTime(time), t)
          : t('status.na', { ns: 'miscellaneous' })
        }
      </span>
    </div>
  );
}

ReportedBy.propTypes = {
  time: PropTypes.string,
  username: PropTypes.string,
};

ReportedBy.defaultProps = {
  time: undefined,
  username: undefined,
};
